export const RENDER_TYPE = {
    DEFAULT: 'PHOTO_VIEW',
    PIXELED: 'PIXELED'
};